<template>
  <div class="row">
    <div class="col-md-12">
      <div v-for="(item, index) in optionsMapGroup" :key="index" class="card mb-2">
        <div class="row d-flex align-items-center">
          <div class="col-md-3 ml-3">
            <div class="card-block">
              <div class="card-title">
                <h6>
                  <strong>{{ item.name }}</strong>
                  <tooltip v-if="item.tooltip.text || item.tooltip.image" style="display: inline-block" :tooltip="item.tooltip">
                    <span class="fa fa-info-circle text-primary" />
                  </tooltip>
                </h6>
                <p v-html="item.print_description" />
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div v-if="item.type === 'check'" class="custom-control custom-checkbox">
              <input v-if="!item.disabled" :id="`custom-check${item.id}`" v-model="item.selected" type="checkbox" class="custom-control-input" @click="checkOption(item)">
              <label class="custom-control-label text-danger" :class="{ 'disabled': item.disabled }" :for="`custom-check${item.id}`">{{ item.price.self | currency }}</label>
            </div>
          </div>
          <div class="col-md-5" :class="{ 'disabled': !item.selected, '': item.selected }">
            <table v-if="item.children.length > 0" class="table table-borderless">
              <tr v-for="(child, idx) in item.children" :key="idx">
                <td>
                  <h6>
                    <strong>{{ child.name }}</strong>
                    <tooltip v-if="child.tooltip.text || child.tooltip.image" style="display: inline-block" :tooltip="child.tooltip">
                      <span class="fa fa-info-circle text-primary" />
                    </tooltip>
                  </h6>
                  <p v-html="child.print_description" />
                </td>
                <td class="text-right">
                  <div v-if="child.type === 'check'" class="custom-control custom-checkbox">
                    <input v-if="!child.disabled" :id="`custom-check${child.id}`" v-model="child.selected" type="checkbox" class="custom-control-input" @click="checkOption(child)">
                    <label class="custom-control-label text-danger" :class="{ 'disabled': child.disabled }" :for="`custom-check${child.id}`">{{ child.price.self | currency }}</label>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <table class="table">
        <tfoot>
          <tr>
            <td><strong>Gesamtmontage</strong></td>
            <td colspan="2">
              <span class="text-danger">{{ total | currency }}</span>
            </td>
          </tr>
          <tr>
            <td colspan="1">
              <strong>Bonus regionaler Kunde</strong>
            </td>
            <td>
              <div class="custom-control custom-checkbox">
                <input v-if="bonusActive" id="custom-check-bonus" type="checkbox" class="custom-control-input" @click="checkBonus">
                <label class="custom-control-label text-danger" for="custom-check-bonus" :class="{ 'disabled': !bonusActive, '': bonusActive }">-{{ 250 | currency }}</label>
              </div>
            </td>
            <td>für regionale Kunde Berlin +50 km</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'MontageStep',
  data: () => ({
    bonus: 250,
    bonusActive: false,
    type: null
  }),
  computed: {
    ...mapGetters({
      step: 'configurator/currentStep',
      montageBonus: 'checkout/montageBonus'
    }),
    options () {
      return this.step.options
    },
    optionsMapGroup () {
      const map = {}
      const options = this.step.options
      options.forEach(option => {
        if (option.dname === 'children') {
          option.show_for.forEach(o => {
            if (map[o].children.indexOf(option) === -1) {
              map[o].children.push(option)
            }
          })
        } else {
          map[option.id] = option
        }
      })
      return map
    },
    total () {
      let price = 0
      this.step.options.filter(o => {
        if (o.selected && !o.disabled) {
          price += o.price.self
        }
      })
      return price
    }
  },
  methods: {
    ...mapActions({
      toggleOption: 'configurator/toggleOption'
    }),
    ...mapMutations({
      setMontageBonus: 'checkout/SET_MONTAGE_BONUS'
    }),
    checkOption (option) {
      this.bonusActive = false
      this.toggleOption(option)
      const s = this.step.options.filter(o => o.selected && o.bonus)
      if (s.length > 0) {
        this.bonusActive = true
      }
    },
    checkBonus (e) {
      const checked = e.target.checked

      if (checked) {
        this.setMontageBonus(-250)
      } else {
        this.setMontageBonus(0)
      }
    }
  }
}
</script>
<style lang="css">
label.disabled {
    color: #888!important;
}
.card .disabled,
.card .disabled span.fa {
    color: #888!important;
}
</style>
